export function validatePasswordComplexity(password) {
  if (typeof password !== 'string') return { valid: false, message: 'Password is required' };
  const minLen = 10;
  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);
  if (password.length < minLen) return { valid: false, message: 'Password must be at least 10 characters' };
  if (!hasUpper || !hasLower || !hasDigit || !hasSpecial) return { valid: false, message: 'Use upper, lower, number, and symbol' };
  return { valid: true };
}


